import { render, staticRenderFns } from "./AuthLanding.vue?vue&type=template&id=c2c20e90&"
import script from "./AuthLanding.vue?vue&type=script&lang=js&"
export * from "./AuthLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports